import { ButtonIcon } from '@vds/button-icons'
import { TextLink } from '@vds/buttons'
import React,{ useEffect, useState } from 'react'
import { Body, Micro } from '@vds/typography'
import { Icon } from '@vds/icons'
import { useSelector } from 'react-redux';
import InstructorCard from '../InstructorCard'
import { decodeHTML } from '../../../utility/common'
import { Modal, ModalBody, ModalTitle } from '@vds/modals';
import { Line } from '@vds/lines';
import './CourseDetailsSection.scss'
import EventPreview from '../../EventDetailsPage/EventPreview/EventPreview';
import MultipleInstructorCard from '../../EventDetailsPage/MultipleInstructorCard/MultipleInstructorCard'

const CourseDetailsSection = ({ isInPersonEvent, allIPEventsWithTimezone, allEventsWithTimeZone, detailsRef, courseDetailsAEMData, forEvent, isAfter, coursePreviewCardData, currentCourse, eventCxAemData }) => {
  const instructorArray =  useSelector((state)=>state.Aem.instructorData);
  const [isExpanded, setIsExpanded] = useState(false);
  const [instructorList, setInstructorList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const { localizeData, tags } = currentCourse ?? {};
  const { disclaimer, showlesstxt, showmoretxt, notes } = courseDetailsAEMData ?? {};
  const lng = localStorage.getItem("lng") ?? "en";
  const locale = lng === "en"? 'en-US' : lng === "es" ? 'es-ES' : "zh-CN";
  const filteredLocalizeData = localizeData?.find((localeVal)=> localeVal?.locale === locale);
  const englishLocalizedData = localizeData?.find((localeVal)=> localeVal?.locale === 'en-US');
  const spanishLocalizeData = localizeData?.find((localeVal)=> localeVal?.locale === 'es-ES')
  const formattedCurrentEvent = forEvent && (isInPersonEvent ? allIPEventsWithTimezone?.find(item => item?.id === currentCourse?.id) : allEventsWithTimeZone?.find(item => item?.id === currentCourse?.id));
  const modifiedTags = (forEvent || isInPersonEvent) && formattedCurrentEvent?.tags?.map((tag) => tag?.replace(/[^a-zA-Z0-9]+/g, "")?.toLowerCase());
  if (isInPersonEvent) {
    modifiedTags?.push(localizeData[0]?.hostDetails?.type?.replace(/[^a-zA-Z0-9]+/g, "").toLowerCase());
  }
  const modifiedDisclaimer = forEvent && disclaimer?.map((dis)=> ({ ...dis, eventType: dis?.eventType?.replace(/[^a-zA-Z0-9]+/g, "")?.toLowerCase() }))
  const decodedDecsription = filteredLocalizeData?.richTextOverview ?? englishLocalizedData?.richTextOverview ?? spanishLocalizeData?.richTextOverview;
  const maxLenth = 350;
  const disclaimerBasedOnEventType = forEvent && modifiedDisclaimer?.find((dis) => modifiedTags?.indexOf(dis?.eventType) != -1);
  const checkDisclaimerType = disclaimerBasedOnEventType?.eventType === "verizon" || disclaimerBasedOnEventType?.eventType === "partner" || disclaimerBasedOnEventType?.eventType === "workshopnetworking" || disclaimerBasedOnEventType?.eventType === "community";
  const commonDisclaimer = forEvent ? notes : disclaimer;
  const fileredInstructorsForEvent =  instructorList?.length > 0 ? instructorList : filteredLocalizeData?.expertsDetails;

  useEffect(() => {
    if (modalOpen) {
      // Prevent background scroll when modal opens
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      return () => {
        // Restore scroll when modal closes
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [modalOpen]);

  useEffect(()=>{
    let instructorArr = [];
    const instructorTagArr = tags?.filter(item=>item.includes('instructor:'));
    instructorArr.push(instructorArray?.instructordata?.instructordata?.filter(e=>instructorTagArr?.includes(e.instructorID)));
    setInstructorList(...instructorArr)
  },[tags, instructorArray])
  
  const handleSeeMoreClick = () => {
    setIsExpanded(!isExpanded);
    detailsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (decodedDecsription && decodedDecsription?.length <= maxLenth) {
    return <>
    <div className='mt-8X sm-mt-6X'><Body size='large'><div className='desc' dangerouslySetInnerHTML={{ __html: decodedDecsription }} /></Body></div>
    {isAfter && forEvent && fileredInstructorsForEvent && (
      <div>
        <div className='mb-8X'>
          {fileredInstructorsForEvent.length > 1 ? (
            <MultipleInstructorCard instructors={fileredInstructorsForEvent} />
          ) : (
            <InstructorCard forEvent={forEvent} instructor={fileredInstructorsForEvent?.[0]} />
          )}
        </div>
        <EventPreview currentEvent={currentCourse} courseCxAemData={eventCxAemData} eventPreviewCardData={coursePreviewCardData} />
      </div>
    )}
      {!isAfter && forEvent && fileredInstructorsForEvent && (
        <div className='mb-8X'>
          {fileredInstructorsForEvent.length > 1 ? (
            <MultipleInstructorCard instructors={fileredInstructorsForEvent} />
          ) : (
            <InstructorCard forEvent={forEvent} instructor={fileredInstructorsForEvent?.[0]} />
          )}
        </div>
      )}</>
  }


  return (
    <>
      {decodedDecsription &&
       <>
       <div className='mt-8X sm-mt-6X'>
        <Body size='large'>
          <div className='desc' dangerouslySetInnerHTML={{ __html: isExpanded ? decodedDecsription : decodedDecsription?.slice(0,maxLenth) + '...' }} />
        </Body>
      </div>
        {isExpanded && 
          <div className='mt-6X mb-8X'>
            <div className='disclaimer_top_line_width'>
              <Line type='primary' />
            </div>
            {<div className='mt-6X mb-4X'>
              <Micro>
              {commonDisclaimer ? decodeHTML(commonDisclaimer) : null}
              </Micro>
            </div>}
            {forEvent && checkDisclaimerType && 
            (disclaimerBasedOnEventType?.modalTitle && disclaimerBasedOnEventType?.modalContent ? (<TextLink
              type="standAlone"
              size="small"
              role="button"
              ariaLabel="Notice of Filming & Photography"
              onClick={() => setModalOpen(true)}
               className="micro"
            ><div className="micro-text">
              <Micro>
              {decodeHTML(disclaimerBasedOnEventType?.disclaimerContent)}
              </Micro>
              </div>
            </TextLink>) : (
          <span
              type="standAlone"
              size="small"
              role="button"
              ariaLabel="Notice of Filming & Photography"
               className="micro"
            ><div><Micro>
              {decodeHTML(disclaimerBasedOnEventType?.disclaimerContent)}
              </Micro>
              </div>
            </span>))}
            {forEvent && checkDisclaimerType && <Modal
              opened={modalOpen}
              surface="light"
              fullScreenDialog={false}
              disableAnimation={false}
              disableOutsideClick={false}
              ariaLabel="Notice of Filming & Photography"
              closeButton={
                <button
                  id='closeButton' 
                  tabIndex={0} 
                  aria-label={`popup close`}
                  onClick={() => setModalOpen(false)}
                  role='button' 
                  className='modalIcon'
                >
                  <Icon name="close" size="medium" color="#000000"
                />
                </button>
              }
              onOpenedChange={(e) => { if (!e) { setModalOpen(false); } }}
            >
              <ModalTitle>
                {decodeHTML(disclaimerBasedOnEventType?.modalTitle)}
              </ModalTitle>
              <ModalBody>
                <div className="text-block-container">
                  <Body size="large">
                    <div className='desc' dangerouslySetInnerHTML={{ __html: disclaimerBasedOnEventType?.modalContent }} />
                  </Body>
                </div>
              </ModalBody>
            </Modal>}
          </div>
        }
      <div className='mt-2X mb-6X n-displayFlex showmore-container'>
      <span className='icon-wraper'>
      <ButtonIcon 
          kind="ghost"
          size="small"
          className="button-icon-plus" 
          tabIndex={-1}
          aria-hidden="true"
          onClick={handleSeeMoreClick}
          onKeyDown={(e)=>{
            if(e.key==="Shift" || e.key==="Enter"){
              e.preventDefault();
              handleSeeMoreClick();
            }
          }}
          renderIcon={(props) => !isExpanded ? <Icon name="plus" color='#fff' {...props} /> : <Icon name="minus" color='#fff' {...props} />}
        />
        </span>
        <TextLink
          type="standAlone"
          className="showmore-text"
          onClick={handleSeeMoreClick}
          >
          {!isExpanded ? showmoretxt : showlesstxt}
        </TextLink>     
      </div>
      </>}
      {!forEvent && instructorList?.map((item)=>(
        <InstructorCard instructor={item}/> 
      ))} 
     {isAfter && forEvent && fileredInstructorsForEvent && (
        <div>
          <div className='mb-8X'>
            {fileredInstructorsForEvent.length > 1 ? (
              <MultipleInstructorCard instructors={fileredInstructorsForEvent} />
            ) : (
              <InstructorCard forEvent={forEvent} instructor={fileredInstructorsForEvent?.[0]} />
            )}
          </div>
          <EventPreview currentEvent={currentCourse} courseCxAemData={eventCxAemData} eventPreviewCardData={coursePreviewCardData} />
        </div>
      )}
      {!isAfter && forEvent && fileredInstructorsForEvent && (
        <div className='mb-8X'>
          {fileredInstructorsForEvent.length > 1 ? (
            <MultipleInstructorCard instructors={fileredInstructorsForEvent} />
          ) : (
            <InstructorCard forEvent={forEvent} instructor={fileredInstructorsForEvent?.[0]} />
          )}
        </div>
      )}
    </>
  )
}

export default CourseDetailsSection